<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 25" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <template v-else>
      <v-card>
        <fields :model="modelObj" ref="productReference"
          :isWorkType="isWorkType"  :showPriceUpdateText="showPriceUpdateText"
          @gross-margin="setGrossMarginValue" :copyProduct="copyProduct" :copyConfirmation="copyConfirmation"
          :isPackageHaveItems="productItems && productItems.length > 0"
          :list="{ groups: [...listOfProductGroups], units: [...listOfUnits], sales_accounts: [...listOfSalesAccounts], workflows: [...listOfWorkflows], productClasses: [...listOfProductClasses] }"
          :key="reInitFields">
        </fields>
        <v-card class="pb-2 mb-5" v-if="modelObj.id && modelObj.ispackage">
          <v-card-title class="pb-0">
            {{ $t('message.layout.products') }}
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mb-1" @click="getContentHandler" :loading="contentLoader">{{ $t('message.orders.contents') }}</v-btn>
          </v-card-title>
          <v-divider class="mb-3"></v-divider>
          <packageproducts :model="modelObj" :modelId="modelObj.id" :list="{ suppliers: [...listOfSuppliers], units: [...listOfUnits], workflows: [...listOfWorkflows] }"
            @productsLoaded="getProductItems"
            :listOfOperationTypes="listOfOperationTypes"
            @priceUpdate="priceCalculation"></packageproducts>
        </v-card>
        <v-expansion-panels v-if="modelObj.id">
          <suppliers v-if="isWorkType" :model="modelObj" :list="{ suppliers: [...listOfSuppliers], currencies: [...listOfCurrencyList] }"></suppliers>
          <attachments :model="modelObj" :key="reInit" :module="SP_PRODUCT"></attachments>
          <openorders :model="modelObj"></openorders>
          <batches :model="modelObj"></batches>
          <pricehistory :model="modelObj"></pricehistory>
        </v-expansion-panels>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="loading" @click="saveUpdateHandler(SAVE)" :disabled="disableBtn">{{ modelObj.id ? $t('message.common.update') : $t('message.common.save') }}</v-btn>
          <v-btn color="primary" :loading="loading" @click="saveUpdateHandler(UPDATE_CLOSE)" v-if="modelObj.id" :disabled="disableBtn">{{ $t('message.common.updateAndClose') }}</v-btn>
          <v-btn color="info" @click="$router.push(`/w_h/${MODULE_URL}`)">{{ $t('message.common.backToList') }}</v-btn>
          <v-btn color="error" @click="deleteHandler" v-if="modelObj.id">{{ $t('message.common.delete') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="nestedDialog" persistent width="1000">
        <v-card>
          <v-card-text class="pt-3">
            <v-simple-table dense width="100%" class="dense_table bordered--table">
              <thead>
                <tr>
                  <th>{{ $t('message.layout.product') }}</th>
                  <th>{{ $t('message.product.suppliers') }}</th>
                  <th>{{ $t('message.whOrder.unitCost') }}</th>
                  <th>{{ $t('message.product.salesPrice') }}</th>
                  <th>{{ $t('message.order.qty') }}</th>
                  <th>{{ $t('message.common.comments') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, i) in nestedContents" :key="i">
                  <td class="pa-1" :class="`pl-${product.paddingindex}`">{{ product.productnumber }} {{ product.productname }}</td>
                  <td class="pa-1">{{ product.suppliername }}</td>
                  <td class="pa-1 text-right">{{ product.unitcost | replaceDotWithComma }}</td>
                  <td class="pa-1 text-right">{{ product.salesprice | replaceDotWithComma }}</td>
                  <td class="pa-1 text-right">{{ product.qty | replaceDotWithComma }}</td>
                  <td class="pa-1">{{ product.comments }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="nestedDialog = false">{{ $t('message.common.close') }} </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="copyConfirmation.dialog" persistent width="500">
        <v-card>
          <v-card-title>
            {{ $t('message.common.confirmation') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-radio-group v-model="copyConfirmation.model" row>
              <v-radio :label="$t('message.products.copyAsNew')" :value="1"></v-radio>
              <v-radio :label="$t('message.products.copyOnlyContents')" :value="2"></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="copyConfirmation.open">{{ $t('message.common.save') }}</v-btn>
            <v-btn color="info" @click="copyConfirmation.dialog = false">{{ $t('message.common.close') }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="copyProduct.dialog" persistent width="1000" fullscreen>
        <v-card>
          <template v-if="copyConfirmation.model === 1">
            <fields :model="copyPayload" ref="copyProductReference"
              :isWorkType="isWorkType" :showPriceUpdateText="showPriceUpdateText"
              @gross-margin="setGrossMarginValue" :copyProduct="{ ishow: false }"
              :list="{ groups: [...listOfProductGroups], units: [...listOfUnits], sales_accounts: [...listOfSalesAccounts] }"
              @supportingList="supportingList" :key="reInitFields">
            </fields>
          </template>
          <v-card class="pb-2 mb-5" v-if="copyPayload.ispackage">
            <v-card-title class="pb-0">
              <v-row>
                <v-col cols="8">
                  {{ $t('message.layout.products') }}
                </v-col>
                <v-col cols="4" v-if="copyConfirmation.model === 2">
                  <v-autocomplete dense hide-details v-model="copyPayload.copyto" :items="packagesList" item-text="name" item-value="id"
                    outlined :label="$t('message.products.copyTo')"></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="mb-3"></v-divider>
            <packageproducts :model="copyPayload" :modelId="modelObj.id" :list="{ suppliers: [...listOfSuppliers], units: [...listOfUnits], workflows: [...listOfWorkflows] }"
              @productsLoaded="getProductItems"
              :listOfOperationTypes="listOfOperationTypes"
              @priceUpdate="priceCalculation"></packageproducts>
          </v-card>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="loading" @click="copyProductObjHandler">{{ $t('message.common.save') }}</v-btn>
            <v-btn color="info" @click="copyProduct.dialog = false">{{ $t('message.common.close') }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>
<script>
import moment from 'moment'
/* eslint-disable camelcase */
import { mapState } from 'vuex'
export default {
  data () {
    return {
      fieldsLoading: false,
      modelObj: {
        id: this.$route.params.product_id || 0,
        type: '',
        costprice: '',
        grosmargin: '',
        salesprice: ''
      },
      productPackage: {},
      MODULE_URL: 'products',
      loading: false,
      productTransformList: ['costprice', 'grosmargin', 'salesprice', 'salespriceincvat', 'baseprice', 'available', 'minstock', 'orderqty', 'leadtime',
        'length', 'width', 'thickness', 'weight', 'radius', 'area', 'minlength', 'minwidth', 'minthickness',
        'maxlength', 'maxwidth', 'maxthickness'],
      packageProducts: [],
      packageProductsError: false,
      listOfCurrencyList: [],
      productItems: [],
      PLANNING_ID: +process.env.VUE_APP_ORDER_PLANNING_ID,
      disableBtn: false,
      reInit: 0,
      reInitFields: 0,
      canReloadDocument: false,
      showPriceUpdateText: false,
      actualPriceDate: '',
      contentLoader: false,
      nestedContents: [],
      nestedDialog: false,
      copyConfirmation: {
        dialog: false,
        model: 1,
        click: this.copyConfirmationHandler,
        open: () => {
          this.copyProduct.open()
        }
      },
      copyProduct: {
        isshow: true,
        dialog: false,
        open: () => {
          this.copyHandler()
        }
      },
      copyPayload: {},
      packagesList: []
    }
  },
  watch: {
    'modelObj.priceValidFromPicker' (val) {
      if (val) {
        this.modelObj.pricevalidfrom = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    }
  },
  components: {
    fields: () => import('@/components/Product/Fields'),
    suppliers: () => import('@/components/Product/Suppliers'),
    attachments: () => import('@/components/Attachments'),
    batches: () => import('@/components/Product/Batches'),
    packageproducts: () => import('@/components/Product/ProductPackage'),
    openorders: () => import('@/components/Product/OpenOrders'),
    pricehistory: () => import('@/components/Product/PriceHistory')
  },
  computed: {
    ...mapState(['listOfProductGroups', 'listOfUnits', 'listOfSalesAccounts', 'listOfSuppliers', 'listOfWorkflows',
      'listOfProductClasses']),
    isWorkType () {
      if (this.modelObj.type && this.modelObj.type === 'work') return false
      else return true
    },
    listOfOperationTypes () {
      if (this.$store.state.workFlowStates && this.$store.state.workFlowStates.length > 0) {
        var getListOfOperationTypes = this.$store.state.workFlowStates.slice()
        var getPlanningIndex = getListOfOperationTypes.findIndex(x => x.id === +this.PLANNING_ID)
        if (getPlanningIndex !== -1) getListOfOperationTypes.splice(getPlanningIndex, 1)
        return getListOfOperationTypes
      } else return []
    }
  },
  created () {
    this.$store.dispatch('getSupplierList')
    this.$store.dispatch('getAllWorkflowStates')
    this.getAllCurrencyList()
    this.$store.dispatch('getProductGroups')
      .then(() => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'productgroupid', list: this.$store.state.listOfProductGroups })
        }
      })
    this.$store.dispatch('getUnits')
      .then(() => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'unitid', list: this.$store.state.listOfUnits })
        }
      })
    this.$store.dispatch('getSalesAccount')
      .then(() => {
        if (!this.modelObj.id) {
          this.setDefaultAccount()
        }
      })
    this.$store.dispatch('getProductClasses')
      .then(() => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'ProductClassId', list: this.$store.state.listOfProductClasses })
        }
      })
  },
  mounted () {
    this.getPackages()
    this.$store.dispatch('getWorkflows')
      .then(() => {
        setTimeout(() => {
          this.$eventBus.$emit('checkForWorkflow')
        }, 500)
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'workflow_id', list: this.$store.state.listOfWorkflows })
        }
      })
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteSuccess', (data) => {
      this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
      this.$store.commit('hideDialog')
      if (data === this.MODULE_URL) this.$router.push('/w_h/products')
    })
    this.$eventBus.$on('setChildData', (data) => {
      if (data) {
        this.packageProducts = data
        this.packageProductsError = false
      } else {
        this.packageProductsError = true
        this.packageProducts = []
      }
    })
    this.$eventBus.$on('updateProductUnits', () => {
      this.getProductUnits().then(() => {
        this.reInitFields++
      })
    })
    this.$eventBus.$on('updatedSupplier', () => {
      this.getCostDetails()
    })
    this.$eventBus.$on('calculateGrosMarginValue', () => {
      this.calculateGrosMarginValue()
    })
    this.$eventBus.$on('calculateSalesValue', () => {
      this.calculatSalesPriceValue()
    })
    this.$eventBus.$on('checkForNumberDuplication', () => {
      this.checkForNumberDuplicationAndDisableBtn()
    })
    this.$eventBus.$on('salesPriceHandler', (data) => {
      this.salesCalculationHandler(data.target, data.field, data.type)
    })
    this.$root.$on('get_product_details', () => {
      this.canReloadDocument = true
      this.getSingleRecordHandler()
    })

    if (!this.modelObj.id) {
      this.modelObj.vatid = 25
      this.modelObj.isactive = true
      this.modelObj.stockitem = true
      this.modelObj.inventoryitem = true
      this.modelObj.grosmargin = '0'
      this.modelObj.minstock = '0'
      this.modelObj.orderqty = '0'
      this.modelObj.type = 'product'
      this.modelObj.pricevalidfrom = moment().format('DD.MM.YYYY')
      this.modelObj.units = []
    } else this.getSingleRecordHandler()
    this.$eventBus.$on('setItemInField', (data) => {
      const model = Object.assign({ ...this.modelObj }, { [data.modelName]: data.recordId })
      this.modelObj = model
    })
  },
  methods: {
    checkForNumberDuplicationAndDisableBtn () {
      if (this.modelObj.number) {
        let model = {}
        if (this.modelObj.id) {
          model = { filter: `number eq '${this.modelObj.number}' and id ne ${this.modelObj.id}` }
        } else {
          model = { filter: `number eq '${this.modelObj.number}'` }
        }
        const url = `${this.MODULE_URL}/query/`
        this.$_executeApi('post', url, model)
          .then((response) => {
            if (response.data && response.data.length > 0) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.product.productWithSameNumberExists') })
              this.disableBtn = true
            } else {
              this.disableBtn = false
            }
          })
      }
    },
    getCostDetails () {
      this.$_getSingleRecordHandler(`${this.MODULE_URL}/${this.modelObj.id}`)
        .then((result) => {
          if (result.data) {
            const product = result.data
            const transformData = { number: { list: this.productTransformList, format: 'replaceDotWithComma' } }
            const model = this.$_formatModel(product, transformData)
            this.modelObj.costprice = model.costprice
            this.modelObj.grosmargin = model.grosmargin || 0
            this.modelObj.salesprice = model.salesprice
            this.setGrossMarginValue()
          }
        })
    },
    getSingleRecordHandler () {
      this.fieldsLoading = true
      const query = {
        expand: [{
          Model: 'ProductWorkFlow',
          on_field: 'Id',
          on_parent_field: 'Workflow_Id',
          select: ['states']
        }],
        filter: `id eq ${this.modelObj.id}`
      }
      this.$_executeApi('post', `${this.MODULE_URL}/query`, query)
        .then((result) => {
          if (result.data) {
            const product = result.data && result.data[0] ? result.data[0] : {}
            const transformData = {
              number: { list: this.productTransformList, format: 'replaceDotWithComma' },
              date: { list: ['pricevalidfrom'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' }
            }
            const model = this.$_formatModel(product, transformData)
            model.operation_type = model.operation_type ? +model.operation_type : 0
            this.actualPriceDate = model.pricevalidfrom
            this.modelObj = model
            this.getProductUnits().then(() => {
              this.fieldsLoading = false
              if (this.canReloadDocument) this.reInit++
              this.canReloadDocument = false
            })
            setTimeout(() => {
              this.$eventBus.$emit('checkForWorkflow')
            }, 500)
          }
        })
    },
    saveUpdateHandler (type, iscopy = false) {
      var modelPayload = iscopy ? 'copyPayload' : 'modelObj'
      var validation = iscopy ? 'copyProductReference' : 'productReference'
      if (this.$refs[validation].$refs.validateForm.validate()) {
        if (this[modelPayload].units.length) {
          this.$eventBus.$emit('savingParentObj')
          if (this.packageProductsError === false) {
            this.loading = true
            var previousDate = Date.parse(this.actualPriceDate)
            var updatedDate = Date.parse(this[modelPayload].pricevalidfrom)
            if (previousDate !== updatedDate) {
              this.showPriceUpdateText = true
              setTimeout(() => {
                this.showPriceUpdateText = false
              }, 4000)
            }
            const transformData = {
              number: { list: this.productTransformList, format: 'replaceCommaWithDot' },
              date: { list: ['pricevalidfrom'], from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' }
            }
            if (!this[modelPayload].ispackage) this[modelPayload].openstructure = false
            const model = this.$_formatModel(this[modelPayload], transformData)
            const saleunitobj = model.units.find(x => x.issaleunit)
            if (saleunitobj) {
              model.unitid = saleunitobj.unitid
              model.barcode = saleunitobj.ean || ''
            }
            this.$_saveUpdateHandler(this.MODULE_URL, model)
              .then((response) => {
                this.$store.commit('isChangesMade', false)
                this.saveProductUnits(response.id, model.units).then(() => {
                  this.savePackageProducts(response.id, type, model, iscopy)
                })
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
          }
        } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.product.addAtleastOneUnit') })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    savePackageProducts (id, type, model, iscopy) {
      this.loading = true
      const transformData = { number: { list: ['qty', 'unitcost', 'salesprice'], format: 'replaceCommaWithDot' } }
      let items = this.$formatter.cloneVariable(this.packageProducts)
      items.forEach(x => {
        if (iscopy) x.id = 0
        x.packageid = id
      })
      items = this.$_formatListModel(items, transformData)
      const url = `/productpackages/bulk_save/${id}`
      return this.$_executeApi('post', url, items)
        .then((response) => {})
        .finally(() => {
          this.loading = false
          this.navigationHandler(type, model, id)
        })
    },
    saveProductUnits (productId, units) {
      return new Promise((resolve) => {
        units.forEach(x => {
          x.productid = productId
          if (!x.issupplier) x.minqty = x.orderqty = null
        })
        const transformData = { number: { list: ['qty', 'minqty', 'orderqty'], format: 'replaceCommaWithDot' } }
        let items = this.$formatter.cloneVariable(units)
        items = this.$_formatListModel(units, transformData)
        this.$_executeApi('post', '/productunitmatrix/bulk_save', items)
          .then((response) => {
            this.modelObj.units = response.data
            resolve()
          })
      })
    },
    getProductUnits () {
      return new Promise((resolve) => {
        this.$_executeApi('get', `productunitmatrix/get_by_product/${this.modelObj.id}`)
          .then((response) => {
            const transformData = { number: { list: ['qty', 'minqty', 'orderqty'], format: 'replaceDotWithComma' } }
            this.modelObj.units = this.$_formatListModel(response.data, transformData)
            resolve()
          })
      })
    },
    getAllCurrencyList () {
      this.$_executeApi('get', 'currencies/get_all_currency_list')
        .then((response) => {
          this.listOfCurrencyList = response.data
        })
    },
    navigationHandler (type, model, productId) {
      if (type === this.SAVE && !model.id) this.$router.push(`/w_h/${this.MODULE_URL}/actions/${productId}`)
      else if (type === this.UPDATE_CLOSE) this.$router.push(`/w_h/${this.MODULE_URL}`)
      else if (type === this.SAVE && model.id) this.getSingleRecordHandler()
    },
    deleteHandler () {
      const ids = [this.modelObj.id]
      const payload = { ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
      this.$store.commit('showDeleteDialog', payload)
    },
    async setGrossMarginValue () {
      if (this.modelObj.id && this.modelObj.productgroupid) {
        const query = { filter: `productid eq '${this.modelObj.id}' AND ismain eq '1'` }
        const getMainSupplier = await this.$_executeApi('post', 'productsuppliers/query', query)
        if (getMainSupplier.data) {
          const { supplierid } = getMainSupplier.data[0] ? getMainSupplier.data[0] : { id: 0 }
          if (supplierid) {
            const grossQuery = { filter: `group_id eq '${this.modelObj.productgroupid}' AND supplier_id eq '${supplierid}'` }
            const getGrossMargin = await this.$_executeApi('post', 'grossmargins/query', grossQuery)
            if (getGrossMargin.data) {
              const { gross_margin } = getGrossMargin.data[0] ? getGrossMargin.data[0] : { gross_margin: 0 }
              if (gross_margin) {
                this.modelObj.grosmargin = this.$formatter.replaceDotWithComma(gross_margin)
              } else {
                this.modelObj.grosmargin = '0,00'
              }
              this.calculatSalesPriceValue()
            }
          }
        }
      }
    },
    calculatSalesPriceValue () {
      const costPrice = this.modelObj.costprice ? this.$formatter.replaceCommaWithDot(this.modelObj.costprice) : 0
      const grosMargin = this.modelObj.grosmargin ? this.$formatter.replaceCommaWithDot(this.modelObj.grosmargin) : 0
      if (grosMargin) {
        this.modelObj.salesprice = this.$formatter.replaceDotWithComma((costPrice * (100 + (+grosMargin))) / 100)
      } else this.modelObj.salesprice = this.$formatter.replaceDotWithComma(costPrice)
      this.salesCalculationHandler('salespriceincvat', 'salesprice', 1)
    },
    calculateGrosMarginValue (type) {
      const costPrice = this.modelObj.costprice ? this.$formatter.replaceCommaWithDot(this.modelObj.costprice) : 0
      if (costPrice) {
        const salesPrice = this.modelObj.salesprice ? this.$formatter.replaceCommaWithDot(this.modelObj.salesprice) : 0
        const grosmargin = ((salesPrice - costPrice) / costPrice) * 100
        this.modelObj.grosmargin = grosmargin && !isNaN(grosmargin) && isFinite(grosmargin) ? this.$formatter.replaceDotWithComma(grosmargin) : '0,00'
      }
      if (type === 2) this.modelObj.salespriceincvat = this.$formatter.replaceDotWithComma(this.modelObj.salespriceincvat)
      else this.salesCalculationHandler('salespriceincvat', 'salesprice', 1)
    },
    getProductItems (items) {
      this.productItems = items
    },
    setDefaultValues (data) {
      const { list, prop } = data
      const item = list.find(x => x.isdefault)
      if (item) {
        const model = Object.assign({ ...this.modelObj }, { [prop]: item.id })
        setTimeout(() => {
          this.modelObj = model
        })
      }
    },
    salesCalculationHandler (target, field, type) {
      const getVat = this.modelObj.vatid
      const getField = this.$formatter.replaceCommaWithDot(this.modelObj[field])
      let getValue = 0
      if (type === 1) {
        getValue = (+getField * (getVat + 100) / 100)
      } else if (type === 2) {
        getValue = (+getField / (getVat + 100) * 100)
      }
      this.modelObj[target] = this.$formatter.replaceDotWithComma(getValue)
      if (target === 'salesprice') this.calculateGrosMarginValue(type)
    },
    setDefaultAccount (data) {
      // eslint-disable-next-line eqeqeq
      const item = this.$store.state.listOfSalesAccounts.find(x => x.accountnumber == process.env.VUE_APP_DEFAULT_ACCOUNT_NUMBER)
      if (item) {
        const model = Object.assign({ ...this.modelObj }, { salesaccountid: item.id })
        setTimeout(() => {
          this.modelObj = model
        })
      }
    },
    getContentHandler () {
      this.contentLoader = true
      this.nestedDialog = true
      this.$_executeApi('get', `/productpackages/get_contents_of_nested/${this.modelObj.id}`)
        .then((response) => {
          this.nestedContents = response.data
        })
        .finally(() => {
          this.contentLoader = false
        })
    },
    priceCalculation (result) {
      const prop = result.iscopy ? 'copyPayload' : 'modelObj'
      const getPrices = this.$formatter.cloneVariable(this[prop])
      this[prop] = { ...getPrices, ...result.model }
    },
    supportingList (type, text) {
      const modelName = text
      text = this.$refs.productReference.$refs[text].lazySearch
      const model = { module: type, dialog: true, text, modelName }
      if (type === this.PRODUCT_GROUPS && (text && text.split('-').length > 1)) {
        model.number = text.split('-')[0]
        model.text = text.split('-')[1]
      }
      this.$store.commit('supportingList', model)
    },
    getPackages () {
      const query = {
        filter: `ispackage eq 1 AND id ne ${this.modelObj.id || 0}`
      }
      this.$_executeApi('post', `${this.MODULE_URL}/query`, query)
        .then((result) => {
          if (result.data) {
            this.packagesList = result.data
          }
        })
    },
    copyConfirmationHandler () {
      this.copyConfirmation.dialog = true
    },
    copyHandler () {
      this.copyProduct.dialog = true
      const copyData = this.$formatter.cloneVariable(this.modelObj)
      copyData.id = 0
      copyData.number = ''
      copyData.available = 0
      if (copyData.units) {
        copyData.units.map(x => {
          x.id = 0
          return x
        })
      }
      this.copyPayload = copyData
    },
    async copyProductObjHandler () {
      if (this.copyConfirmation.model === 1) this.saveUpdateHandler(this.SAVE, true)
      else if (this.copyConfirmation.model === 2) {
        if (this.copyPayload.copyto) {
          const model = { id: 0 } // this is given to fulfill the navigation method but ID is not correct value
          this.$eventBus.$emit('savingParentObj')
          await this.savePackageProducts(this.copyPayload.copyto, this.SAVE, model, true)
        } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.products.copyToValidation') })
      }
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('setChildData')
    this.$eventBus.$off('calculateGrosMarginValue')
    this.$eventBus.$off('checkForNumberDuplication')
    this.$eventBus.$off('calculateSalesValue')
    this.$eventBus.$off('updatedSupplier')
    this.$eventBus.$off('salesPriceHandler')
    this.$root.$off('get_product_details')
    this.$eventBus.$off('setItemInField')
    this.$eventBus.$off('updateProductUnits')
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  }
}
</script>
